export const getDefault = () => {
  const schema = {
    name: 'MultiColumns',
    data: [
      {
        title: 'Título 1',
        href: 'https://www.ua.pt',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse semper tellus eu massa aliquam euismod. Donec dignissim, leo vel sodales bibendum, nibh justo commodo ante, vitae fermentum turpis quam quis tellus.'
      },
      {
        title: 'Título 2',
        href: 'https://www.ua.pt',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse semper tellus eu massa aliquam euismod. Donec dignissim, leo vel sodales bibendum, nibh justo commodo ante, vitae fermentum turpis quam quis tellus.'
      }
    ]
  }
  return schema
}
